export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": '6d50b51c24msh9a090d9bcb34928p1d5f4bjsn17f81c61024f',
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com"
  }
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "6b871c38e29f8b64e61181186490b2e7";